import { useNavigate } from "react-router-dom";
const PatientNotRegistered = () => {
  const navigate = useNavigate();
  return (
    <div className="pageContainer row justify-center">
      <div className="textCenter">
        <div className="h1">Your profile isn't activated yet</div>
        <div className="b1">
          Please contact your clinician to register your profile.
        </div>
        <button className="button1 h3" onClick={() => navigate("/signin")}>
          Back to login
        </button>
      </div>
    </div>
  );
};
export default PatientNotRegistered;
